module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_sapporo@3x-9a92b87c53da2c6d2e32d9fec231732c.webp";